import React from 'react';
import { Avatar, ListItem, ListItemAvatar, ListItemText, makeStyles } from '@material-ui/core';
import { Description } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  listItemWrapper: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const FileDownloaderAcerBrag = ({ data, action }) => {
  const classes = useStyles();
  return (
    <div>
      {data &&
        data.map((name, i) => (
          <ListItem className={classes.listItemWrapper} key={i} button onClick={() => action(name)}>
            <ListItemAvatar>
              <Avatar className={classes.avatar}>
                <Description />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={name} />
          </ListItem>
        ))}
    </div>
  );
};

export default FileDownloaderAcerBrag;
